export default (state, action) => {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        prospects: action.prospects,
      };

    case 'SELECT_PROSPECT':
      return {
        ...state,
        currentProspect: action.prospect,
      };
    case 'CLOSE_MODAL':
      return {
        ...state,
        currentProspect: null,
      };
    case 'UPDATE':
      return {
        ...state,
        prospects: state.prospects.map((item) => (item.id === action.prospect.id ? action.prospect : item)),
      };
    default:
      throw new Error();
  }
};
